import(/* webpackMode: "eager" */ "/app/src/app/dev/docs/layout.tsx");
